export default __webpack_public_path__ + "static/media/lots_cubes.55a77cfa.png";